/**
 * SensitivityBadge — small colored pill showing a document's sensitivity level.
 * Usage: <SensitivityBadge level="pii" size="sm" />
 */
import { Badge } from '@/components/ui/badge';
import { Lock } from 'lucide-react';

const META = {
  public:       { label: 'Public',       color: '#34C759' },
  internal:     { label: 'Internal',     color: '#007AFF' },
  confidential: { label: 'Confidential', color: '#FF9500' },
  legal:        { label: 'Legal',        color: '#AF52DE' },
  pii:          { label: 'PII',          color: '#FF3B30' },
  hipaa:        { label: 'HIPAA',        color: '#FF3B30' },
};

const SensitivityBadge = ({ level = 'internal', size = 'sm', showLock = true, className = '' }) => {
  const m = META[level] || META.internal;
  const isSensitive = ['confidential', 'legal', 'pii', 'hipaa'].includes(level);
  const txt = size === 'sm' ? 'text-[10px]' : 'text-xs';
  return (
    <Badge
      className={`${txt} font-semibold tracking-wide ${className}`}
      style={{ backgroundColor: `${m.color}15`, color: m.color }}
      data-testid={`sensitivity-badge-${level}`}
    >
      {showLock && isSensitive && <Lock className="w-2.5 h-2.5 mr-1" />}
      {m.label.toUpperCase()}
    </Badge>
  );
};

export default SensitivityBadge;
